import {TranslatedPropCategoryDTO} from "../../dto/TranslatedPropCategoryDTO";

/** A category tag in the category's own colour. `compact` is the squared 28px tag the prop preset editor uses. */
export default function PropLibraryCategoryLabel(props: { category: TranslatedPropCategoryDTO; compact?: boolean }) {
    const {category, compact} = {...props};

    function hexToRgb(hex: string) {
        // Handle 3-digit hex shorthand (#RGB)
        const fullHex = hex.length === 4 ? hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, '#$1$1$2$2$3$3') : hex;
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : { r: 128, g: 128, b: 128 }; // Default to gray if invalid
    }

    const rgb = hexToRgb(category.hexColor);

    return <div style={{backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`}} className={compact ? "flex gap-[6px] h-[28px] pl-[8px] pr-[10px] rounded-[6px] text-[13px]" : "flex gap-[10px] h-[36px] px-[10px] rounded-full"}>
        <img className={compact ? "my-auto w-[16px] h-[16px]" : "my-auto w-[24px] h-[24px]"} src={category.downloadUri} alt={category.name}/>
        <div style={{color: category.hexColor}} className={"my-auto font-medium"}>
            {category.name.charAt(0).toUpperCase() + category.name.slice(1)}
        </div>
    </div>
}